/* eslint-disable  */
//@ts-nocheck

import { LiveChatTab } from '@client/components/livestreaming/LiveChatTab';
import { SetupTab } from '@client/components/livestreaming/SetupTab';
import { LiveClassesTab } from '@client/components/livestreaming/live-classes/LiveClassesTab';
import { Typography } from '@mui/material';
import { useState } from 'react';
import auth from '../../../components/auth';
import * as styles from './LiveStream.css';

const Menu = ({ openPage, setOpenPage }) => {
  return (
    <div className={styles.menuWrap}>
      <div
        className={styles.menuItem({ active: openPage === 'setup' })}
        onClick={() => setOpenPage('setup')}
      >
        Setup
      </div>
      <div
        className={styles.menuItem({ active: openPage === 'chat' })}
        onClick={() => setOpenPage('chat')}
      >
        Live Chat
      </div>
      <div
        className={styles.menuItem({ active: openPage === 'classes' })}
        onClick={() => setOpenPage('classes')}
      >
        Live Classes
      </div>
    </div>
  );
};

type Tabs = 'setup' | 'chat' | 'classes';

export const LiveStream = ({ influencerId }: { influencerId: number }) => {
  const [openPage, setOpenPage] = useState<Tabs>('chat');

  return (
    <div>
      <Menu {...{ openPage, setOpenPage }} />
      <TabComponent influencerId={influencerId} tab={openPage} />
    </div>
  );
};

const TabComponent = ({
  tab,
  influencerId,
}: {
  tab: Tabs;
  influencerId: number;
}) => {
  switch (tab) {
    case 'setup':
      return (
        <div className={styles.container({ maxw700: true })}>
          <SetupTab influencerId={influencerId} />
        </div>
      );
    case 'chat':
      return (
        <div className={styles.container({ maxw700: true })}>
          <LiveChatTab influencerId={influencerId} />
        </div>
      );
    case 'classes':
      return (
        <div className={styles.container()}>
          <LiveClassesTab influencerId={influencerId} />
        </div>
      );
  }
};
